import React from "react";
import { useNavigate } from "react-router-dom";
import Wrapper from "./Wrapper";
import Menu from "../../images/Legacy/menu.svg"; // Import the Menu icon

export default function QuickPrepScreen({onOpenSidebar,isSidebarOpen}) {
  const navigate = useNavigate();

  const handleStartUnity = () => {
    navigate("/legacy-taara/dashboard", {
      state: {
        userDataString: JSON.parse(localStorage.getItem("user")),
        sceneToLoad: "Roleplay", // Set scene to Roleplay
      },
    });
  };

  return (
         <Wrapper>
      <div className="w-full flex items-center px-6 mt-6 relative">
                 
                       <div className="w-full flex items-center py-4">
                            <button onClick={onOpenSidebar} className="p-2 z-50">
                    {
                      !isSidebarOpen &&          <img src={Menu} alt="Menu Icon" className="w-6 h-6" />
                    
                    }
                            </button>
                            <h2 className="text-lg font-bold mx-auto">{'Start Roleplay'}</h2>
                            <div className="w-6" /> {/* Spacer for alignment */}
                          </div>
                  </div>
                  <div className="w-[333px] bg-[#4E327A] text-white p-6 rounded-lg shadow-lg text-center mt-10 z-10">
  <h3 className="text-lg font-bold flex items-center justify-center gap-2">
    💡 Before You Start
  </h3>

  <p className="mt-3 text-sm font-bold text-left">
    ✨ Before You Begin... Take A Breath.
  </p>
  <p className="mt-1 text-sm text-left">
    Feel the excitement as you step into this journey.
  </p>

  <p className="mt-4 text-sm font-bold text-left">
    🧘‍♂️ Try This:
  </p>
  <p className="mt-1 text-sm text-left">
    Pause and notice your feelings and thoughts in this scenario. Awareness is your ally.
  </p>

  <p className="mt-4 text-sm font-bold text-left">
    🔥 Quick Tips:
  </p>
  <ul className="mt-2 text-sm text-left list-none">
    <li className="pl-3 before:content-['•'] before:pr-2">
      <strong>Set your intention:</strong> Focus on the skill you're practicing.
    </li>
    <li className="pl-3 before:content-['•'] before:pr-2">
      <strong>Stay present:</strong> Respond mindfully, not automatically.
    </li>
    <li className="pl-3 before:content-['•'] before:pr-2">
      <strong>Experiment freely:</strong> This is your space to try new approaches.
    </li>
  </ul>

  <p className="mt-4 text-sm font-bold text-left">
    ✨ Remember:
  </p>
  <p className="mt-1 text-sm text-left">
    Growth comes from practice.<br />
    Celebrate each step forward!
  </p>

  <div className="mt-6 flex justify-center">
    <button className="bg-[#EB4176] text-white px-6 py-2 text-sm font-bold rounded" onClick={handleStartUnity}>
      Let's Go!
    </button>
  </div>
</div>

    </Wrapper>
  );
}